import { type ComponentProps, type Ref } from "react";
import { Table as BaseTable } from "~/components/ui/table";
import { cn } from "~/utils";

interface TableProps extends ComponentProps<typeof BaseTable> {
  variant?: "bordered" | "shadowed";
}

export function Table({
  variant = "bordered",
  ref,
  ...props
}: TableProps & { ref?: Ref<HTMLTableElement> }) {
  return (
    <div
      className={cn(
        "relative w-full overflow-hidden rounded-xl",
        variant === "bordered" && "border border-secondary-200",
        variant === "shadowed" && "shadow-table",
      )}
    >
      <BaseTable ref={ref} {...props} />
    </div>
  );
}

Table.displayName = "Table";
